import { Plus } from "@untitledui/icons";
import type { ReactNode } from "react";
import { Button } from "./button";

interface AddButtonProps {
  children: ReactNode;
  onClick?: () => void;
}

export function AddButton({ children, onClick }: AddButtonProps) {
  return (
    <Button
      color="primary-neutral"
      size="sm"
      onClick={onClick}
      className="bg-fieldpay-highlighter-500 text-fieldpay-blue-700 hover:bg-fieldpay-highlighter-600"
    >
      <span className="flex items-center gap-1">
        <Plus className="size-4 text-fieldpay-blue-700" />
        {children}
      </span>
    </Button>
  );
}
